var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpCarrotWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04807 4.66528C0.780996 4.90387 0.380287 4.86996 0.153058 4.58953C-0.074171 4.30911 -0.0418719 3.88836 0.2252 3.64977L3.92895 0.341C4.04346 0.238707 4.35163 -0.000832001 4.35163 -0.000832001C4.35163 -0.000832001 4.6181 0.227674 4.73848 0.329405L8.65377 3.63818C8.92694 3.86903 8.97016 4.2887 8.7503 4.57553C8.53044 4.86235 8.13076 4.90773 7.85759 4.67688L4.35163 1.71403L1.04807 4.66528Z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5678_66765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04807 4.66528C0.780996 4.90387 0.380287 4.86996 0.153058 4.58953C-0.074171 4.30911 -0.0418719 3.88836 0.2252 3.64977L3.92895 0.341C4.04346 0.238707 4.35163 -0.000832001 4.35163 -0.000832001C4.35163 -0.000832001 4.6181 0.227674 4.73848 0.329405L8.65377 3.63818C8.92694 3.86903 8.97016 4.2887 8.7503 4.57553C8.53044 4.86235 8.13076 4.90773 7.85759 4.67688L4.35163 1.71403L1.04807 4.66528Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5678_66765)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.1602,
    y: 8.82422,
    width: 11.4286,
    height: 12,
    transform: "rotate(-180 10.1602 8.82422)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpCarrotWhite);
export default __webpack_public_path__ + "static/media/up-carrot-white.4d0ab69bd145418a28ca5eac179335f3.svg";
export { ForwardRef as ReactComponent };